import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatistics = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5819_76307)",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M4.25 2C3.00751 2 2 3.00751 2 4.25V15.75C2 16.9925 3.00751 18 4.25 18H15.75C16.9925 18 18 16.9925 18 15.75V4.25C18 3.00751 16.9925 2 15.75 2C15.335 2 15 2.33499 15 2.75C15 3.16501 15.335 3.5 15.75 3.5C16.165 3.5 16.5 3.83499 16.5 4.25V15.75C16.5 16.165 16.165 16.5 15.75 16.5H4.25C3.83501 16.5 3.5 16.165 3.5 15.75V4.25C3.5 3.83499 3.83501 3.5 4.25 3.5H12.75C13.165 3.5 13.5 3.16501 13.5 2.75C13.5 2.33499 13.165 2 12.75 2H4.25Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M10 15.4725C9.65002 15.4725 9.36752 15.19 9.36752 14.84V5.15997C9.36752 4.81247 9.65002 4.52747 10 4.52747C10.35 4.52747 10.6325 4.80997 10.6325 5.15997V14.8425C10.6325 15.19 10.35 15.475 10 15.475V15.4725Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M11.8925 14.84C11.8925 15.19 12.175 15.4725 12.525 15.4725C12.875 15.4725 13.1575 15.1875 13.1575 14.84V7.47247C13.1575 7.12247 12.875 6.83997 12.525 6.83997C12.175 6.83997 11.8925 7.12497 11.8925 7.47247V14.84Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M6.84253 14.84C6.84253 15.19 7.12503 15.4725 7.47504 15.4725C7.82503 15.4725 8.10753 15.1875 8.10753 14.84V9.78748C8.10753 9.43747 7.82503 9.15497 7.47504 9.15497C7.12503 9.15497 6.84253 9.43997 6.84253 9.78748V14.84Z" })
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5819_76307",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(2 2)"
		})
	}) })]
});
export default SvgStatistics;
